import type { ReactElement } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { usePortalSession } from '../auth';
import { Sidebar } from '../components/Sidebar';

export function AppLayout(): ReactElement {
  const { session, logout } = usePortalSession();
  const navigate = useNavigate();
  const location = useLocation();

  const isFullscreen = /^\/spaces\/[^/]+\/simulation$/.test(location.pathname);

  const handleLogout = async (): Promise<void> => {
    await logout();
    navigate('/');
  };

  return (
    <div className="app-shell">
      {/* ── top header bar (hidden in fullscreen pages like Simulation) ── */}
      {!isFullscreen && (
        <header className="app-header">
          <Link to="/spaces" className="app-header-brand">
            GimbalPortal
          </Link>
          <div className="app-header-right">
            {session && (
              <>
                <span className="text-sm text-slate-300">
                  {session.displayName ?? session.email}
                </span>
                <button
                  type="button"
                  onClick={() => void handleLogout()}
                  className="text-sm text-slate-400 hover:text-accent transition-colors"
                >
                  Logout
                </button>
              </>
            )}
          </div>
        </header>
      )}

      {/* ── body: sidebar + content ── */}
      <div className="app-body">
        <Sidebar />
        <main className={`app-content${isFullscreen ? ' app-content--fullscreen' : ''}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
